import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import aiService from "@/services/ai";

export const useDocumentsStore = defineStore("documents", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchDocuments(companyId) {
    loading.value = true;
    try {
      const res = await aiService.getFiles(companyId);
      return res;
    } catch (err) {
      toast.error(err?.message || "Failed to fetch documents");
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteDocument({ company_id, file_id }) {
    loading.value = true;
    try {
      const res = await aiService.deleteFile(company_id, file_id);
      toast.success("Document deleted successfully");
      return res;
    } catch (err) {
      toast.error(err?.message || "Failed to delete document");
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function updateAiData(payload) {
    loading.value = true;
    try {
      const res = await aiService.updateData(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchDocuments,
    deleteDocument,
    updateAiData,
  };
});
